import React, { useState } from 'react'
import Link from 'shared/SlashLink';
import Bg from '../../images/shapes/bg_pattern_3.svg'
import icon1 from '../../images/icons/icon_mail.svg'
import icon2 from '../../images/icons/icon_calling.svg'
import icon3 from '../../images/icons/icon_map_mark.svg'
import icon4 from '../../images/icons/icon_mail_2.svg'
import Services from '../../api/service'
import { WEB3FORMS_ACCESS_KEY } from '../../config/web3forms'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const NewsletterForm = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle | submitting | success | error

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            setStatus('error');
            return;
        }
        setStatus('submitting');
        try {
            const res = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    access_key: WEB3FORMS_ACCESS_KEY,
                    subject: 'New newsletter signup — BUILDLAB website',
                    from_name: 'BUILDLAB Newsletter',
                    email,
                }),
            });
            const data = await res.json();
            if (data.success) { setStatus('success'); setEmail(''); }
            else { setStatus('error'); }
        } catch (err) { setStatus('error'); }
    };

    return (
        <>
            <form className="footer_newslatter" onSubmit={onSubmit}>
                <label htmlFor="footer_mail_input">
                    <img src={icon4} alt="Mail SVG Icon" />
                </label>
                <input
                    id="footer_mail_input"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    aria-label="Email address for BUILDLAB newsletter"
                />
                <button type="submit" disabled={status === 'submitting'} aria-label="Subscribe">
                    <i className="fa-solid fa-paper-plane" aria-hidden="true"></i>
                </button>
            </form>
            {status === 'success' && <p className="mb-0 mt-2" style={{ color: '#7CFFB2', fontSize: '.85rem' }}>Thanks — you're subscribed.</p>}
            {status === 'error' && <p className="mb-0 mt-2" style={{ color: '#ffb3b3', fontSize: '.85rem' }}>Enter a valid email, or try again shortly.</p>}
        </>
    );
};


const Footer = (props) => {
    return (
        <footer className="site_footer footer_layout_1">
            <div className="content_box" style={{ backgroundImage: `url(${Bg})` }}>
                <div className="container">
                    <div className="diract_contact_links text-white">
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon1} alt="Mail SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Write to us</h3>
                                <p className="mb-0">
                                    info@buildlabconsulting.com
                                </p>
                            </div>
                        </div>
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon2} alt="Calling Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title"> Call Us (USA)</h3>
                                <p className="mb-0">
                                    (858) 952-6234
                                </p>
                            </div>
                        </div>
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon3} alt="Map Mark Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Our Office</h3>
                                <p className="mb-0">
                                    Rincon Villa Pl, Escondido, CA 92027
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="footer_main_content">
                        <div className="row justify-content-lg-between">
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footer_widget pe-md-3">
                                    <h2 className="footer_info_title">Newsletter</h2>
                                    <p>
                                        Sign up to BUILDLAB weekly newsletter to get the latest updates.
                                    </p>
                                    <NewsletterForm />
                                    <ul className="social_links_block unordered_list">
                                        <li><a href="https://www.linkedin.com/company/buildlabconsulting/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                                        <li><a href="https://www.facebook.com/buildlab.consulting" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                                        <li><a href="https://twitter.com/buildlabsvcs" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                                        <li><a href="https://www.instagram.com/buildlabconsulting/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Services</h3>
                                    <ul className="icon_list unordered_list_block">
                                        {Services.slice(0, 7).map((service, srv) => (
                                            <li key={srv}>
                                                {service.title ?
                                                    <Link onClick={ClickHandler} to={service.link || `/service-single/${service.slug}`}>
                                                        <span className="icon_list_text">
                                                            {service.title}
                                                        </span>
                                                    </Link>
                                                    : ''}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Affordable Housing</h3>
                                    <ul className="icon_list unordered_list_block">
                                        <li><Link onClick={ClickHandler} to="/affordable-housing"><span className="icon_list_text">Affordable Housing</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/client-onboarding"><span className="icon_list_text">Developer Onboarding</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/feasibility-pro-forma"><span className="icon_list_text">Feasibility Pro Forma</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/tcac-scoring-estimator"><span className="icon_list_text">TCAC 9% Scoring Estimator</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/tcac-broadband-estimator"><span className="icon_list_text">TCAC Broadband Estimator</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/income-rent-limits"><span className="icon_list_text">Income &amp; Rent Limits</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/ctcac-deadlines"><span className="icon_list_text">CTCAC Deadline Calendar</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/das-erccs-checker"><span className="icon_list_text">DAS / ERCCS Checker</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/area-of-refuge-checker"><span className="icon_list_text">Area of Refuge Checker</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/low-voltage-budget-estimator"><span className="icon_list_text">Low-Voltage Budget</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/low-voltage-project-request"><span className="icon_list_text">Request a LV Proposal</span></Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Business IT</h3>
                                    <ul className="icon_list unordered_list_block">
                                        <li><Link onClick={ClickHandler} to="/it-services"><span className="icon_list_text">IT Services &amp; Managed IT</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/it-cost-calculator"><span className="icon_list_text">IT Cost Calculator</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/cyber-security-scorecard"><span className="icon_list_text">Cyber Security Scorecard</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/website-audit"><span className="icon_list_text">Free Website Audit</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/proforma-pressure-test"><span className="icon_list_text">Pro Forma Pressure Test</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/tool-studio"><span className="icon_list_text">Tool Studio — Build a Tool</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/ai-readiness-assessment"><span className="icon_list_text">AI Readiness Assessment</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/cloud-migration-estimator"><span className="icon_list_text">Cloud Migration Estimator</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/service-single/AI-Business-Integration"><span className="icon_list_text">AI Business Integration</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/same-day-websites"><span className="icon_list_text">Same Day Websites</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/startup-package"><span className="icon_list_text">Startup Package</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/custom-software"><span className="icon_list_text">Software &amp; Custom Solutions</span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/indicators"><span className="icon_list_text">Trading Indicators</span></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_bottom">
                <div className="container">
                    <ul className="unordered_list justify-content-center" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 24px', justifyContent: 'center', listStyle: 'none', margin: '0 0 14px', padding: 0 }}>
                        <li><Link onClick={ClickHandler} to="/about" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>About</Link></li>
                        <li><Link onClick={ClickHandler} to="/managed-it-offer" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Managed IT Offer</Link></li>
                        <li><Link onClick={ClickHandler} to="/pricing" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Pricing</Link></li>
                        <li><Link onClick={ClickHandler} to="/portfolio" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Portfolio</Link></li>
                        <li><Link onClick={ClickHandler} to="/blog" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Blog</Link></li>
                        <li><Link onClick={ClickHandler} to="/locations" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Service Areas</Link></li>
                        <li><Link onClick={ClickHandler} to="/contact" style={{ color: 'var(--bs-white)', fontWeight: 600, fontSize: '.88rem' }}>Contact</Link></li>
                    </ul>
                    <div className="d-md-flex align-items-md-center justify-content-md-between">
                        <p className="copyright_text m-0">
                            Copyright © 2026 BUILDLAB — technology consulting &amp; design serving clients across California. All rights reserved.
                        </p>
                        <p className="copyright_text m-0">
                            Developed by <Link onClick={ClickHandler} to="/">BuildLab Consulting</Link>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;